import GoogleAnalyticsCore from './GoogleAnalyticsCore';
import Logger from '../../functions/logging';

class GoogleAnalyticsVisitAdapter extends GoogleAnalyticsCore {
	constructor() {
		super();
		this.className = 'GoogleAnalyticsVisitAdapter';
	}

	reportAnalyticsEvent(aevent) {

		try {
			Logger.log(this.className + ' Logging visit to google analytics : ', aevent);
			//:NOTE:: we need to decide if we want titles on our pages or not
			this.dispatchPageView(aevent.simulatedURL, '');
		} catch (e) {
			throw (this.className + 'Unable to log to Google Analytics Visit : ' + e.message);
		}
	}
}

export default GoogleAnalyticsVisitAdapter;


// WEBPACK FOOTER //
// ./src/analytics/google-analytics-adapter/GoogleAnalyticsVisitAdapter.js